import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProducts = async () => (await api.get("/products")).data;
export const fetchProduct = async (slug) => (await api.get(`/products/${slug}`)).data;
export const fetchRelated = async (slug) => (await api.get(`/products/${slug}/related`)).data;
